<template>
  <div>
    <!-- Escritorio -->
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-row>
        <v-col cols="12" class="text-right">
          <v-btn
            rounded
            dark
            outlined
            color="#00a7e4"
            @click="changeComponent"
            style="margin-right: 11px;"
          >
            <span style="padding-right: 11%;">Cancelar</span>
          </v-btn>
          <v-btn rounded dark class="common-botton" @click="formatInfoComplete">
            <span style="padding-right: 11%;">Guardar</span>
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <commond-form
        :request="data"
        :route="routesConfig.route"
        :run="run"
        :action="routesConfig.action"
        @cancel="run = false"
        @success="afterSuccess"
        @afterError="changeComponent"
      >
        <template v-slot:data>
          <v-row>
            <!-- Rol -->
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                label="Rol"
                :items="listings.roles"
                item-text="nombre"
                item-value="id"
                v-model="data.rol"
                outlined
                :rules="requiredRule"
                :disabled="!canEditRol"
              />
            </v-col>

            <!-- Fecha ingreso -->
            <v-col cols="12" sm="6" md="3">
              <v-menu
                v-model="menuFechaIngreso"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                outlined
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fechaIngresoFormatted"
                    label="Fecha de ingreso"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    color="#00a7e4"
                    :rules="requiredRule"
                  />
                </template>
                <v-date-picker
                  v-model="data.fecha_ingreso"
                  no-title
                  @input="menuFechaIngreso = false"
                />
              </v-menu>
            </v-col>

            <!-- Turno -->
            <v-col cols="12" sm="6" md="3" v-if="showTurno && !isPostVentaRol">
              <v-select
                v-model="data.turno"
                :items="turnoList"
                item-text="turno"
                item-value="id"
                label="Turno"
                outlined
                color="#00a7e4"
              />
            </v-col>

            <!-- Extensión solo para VALIDADORCC (misma regla) -->
            <v-col cols="12" sm="6" md="3" v-if="data.rol === 'VALIDADORCC'">
              <v-text-field
                label="Extensión"
                v-model="data.extension"
                outlined
                color="#00a7e4"
              />
            </v-col>

            <!-- Ramo -->
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                v-model="data.ramos"
                :items="listings.ramoList"
                item-text="ramo"
                item-value="id"
                label="Ramo"
                multiple
                outlined
                color="#00a7e4"
                :disabled="data.rol === 'AGENT' || !canEditRamo"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip color="primary" v-if="index === 0">
                    <span>{{ item.etiqueta }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ data.ramos.length - 1 }} más)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Canal -->
            <!-- <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                v-model="data.canales"
                :items="listings.canalList"
                label="Canal"
                item-text="etiqueta"
                item-value="id"
                multiple
                outlined
                color="#00a7e4"
                :disabled="data.rol === 'AGENT'"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip color="primary" v-if="index === 0">
                    <span>{{ item.etiqueta }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ data.canales.length - 1 }} más)
                  </span>
                </template>
              </v-autocomplete>
            </v-col> -->

            <!-- Productos (landings) mismos roles que tenías -->
            <v-col
              cols="12"
              sm="6"
              md="3"
              v-if="
                data.rol === 'ADMINCC' ||
                  data.rol === 'MANAGERCC' ||
                  data.rol === 'AGENTCC'
              "
            >
              <v-autocomplete
                v-model="data.landings"
                :items="listings.landings"
                label="Campañas"
                item-value="id"
                item-text="landing"
                multiple
                outlined
                color="#00a7e4"
                :disabled="!canEditCampania"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip color="primary" v-if="index === 0">
                    <span>{{ item.landing }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ data.landings.length - 1 }} más)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                  v-model="data.callCenter"
                  :items="listings.callCenter"
                  label="Call Center"
                  item-value="id"
                  item-text="nombre"
                  outlined
                  color="#00a7e4"
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="3" v-if="showEmpresas">
              <v-select
                v-model="data.cuentas_correo"
                :items="cuentasCorreo"
                label="Cuentas correo"
                item-text="cuenta"
                item-value="id"
                multiple
                outlined
                color="#00a7e4"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip color="primary" v-if="index === 0">
                    <span>{{ item.cuenta }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ data.cuentas_correo.length - 1 }} más)
                  </span>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="6" md="3" v-if="showEmpresas">
              <EmpresaSelector
                :cuentaCorreoId="data.cuentas_correo"
                v-model="data.empresas"
                item-value="id"
                item-text="empresa"
              />
            </v-col>

            <v-col cols="12" sm="6" md="3" v-if="showAreasNegocio">
              <v-select
                v-model="data.areas_negocio"
                :items="areasNegociosFiltradas"
                label="Áreas de negocio"
                item-text="nombre"
                item-value="id"
                multiple
                outlined
                color="#00a7e4"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip color="primary" v-if="index === 0">
                    <span>{{ item.nombre }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ data.areas_negocio.length - 1 }} más)
                  </span>
                </template>
              </v-select>
            </v-col>

            <!-- Área (PBP-2018): visible siempre, no depende del rol del agente visto -->
            <v-col cols="12" sm="6" md="3">
              <v-select
                label="Área"
                :items="listings.areasAgente"
                item-text="name"
                item-value="id"
                v-model="data.area"
                outlined
                color="#00a7e4"
                :disabled="!canEditArea"
              />
            </v-col>

            <!-- Estatus de asignación (PBP-2018): visible siempre, no depende del rol del agente visto -->
            <v-col cols="12" sm="6" md="3">
              <v-select
                label="Estatus"
                :items="listings.estatusAsignacion"
                item-text="name"
                item-value="id"
                v-model="data.estatusAsignacion"
                outlined
                color="#00a7e4"
                :disabled="!canEditEstatus"
              >
                <template v-slot:item="{ item }">
                  <v-icon small :color="item.color" class="mr-2">{{ item.icon }}</v-icon>
                  <span>{{ item.name }}</span>
                </template>
                <template v-slot:selection="{ item }">
                  <v-icon small :color="item.color" class="mr-2">{{ item.icon }}</v-icon>
                  <span>{{ item.name }}</span>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </template>
      </commond-form>
    </template>

    <!-- Móvil (mismas reglas, layout en columna) -->
    <template v-else>
      <div class="mobile-container">
        <commond-form
          :request="data"
          :route="routesConfig.route"
          :run="run"
          :action="routesConfig.action"
          @cancel="run = false"
          @success="afterSuccess"
          @afterError="changeComponent"
        >
          <template v-slot:data>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  label="Rol"
                  :items="listings.roles"
                  item-text="nombre"
                  item-value="id"
                  v-model="data.rol"
                  outlined
                  :rules="requiredRule"
                  :disabled="data.rol === 'AGENT'"
                />
              </v-col>

              <v-col cols="12">
                <v-menu
                  v-model="menuFechaIngreso"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  outlined
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechaIngresoFormatted"
                      label="Fecha de ingreso"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      color="#00a7e4"
                      :rules="requiredRule"
                    />
                  </template>
                  <v-date-picker
                    v-model="data.fecha_ingreso"
                    no-title
                    @input="menuFechaIngreso = false"
                  />
                </v-menu>
              </v-col>

              <v-col cols="12" v-if="showTurno">
                <v-text-field
                  label="Turno"
                  v-model="data.turno"
                  outlined
                  color="#00a7e4"
                />
              </v-col>

              <v-col cols="12" v-if="data.rol === 'VALIDADORCC'">
                <v-text-field
                  label="Extensión"
                  v-model="data.extension"
                  outlined
                  color="#00a7e4"
                  :disabled="!canEditExtension"
                />
              </v-col>

              <v-col cols="12">
                <v-autocomplete
                  v-model="data.ramos"
                  :items="listings.ramoList"
                  item-text="ramo"
                  item-value="id"
                  label="Ramo"
                  multiple
                  outlined
                  color="#00a7e4"
                  :disabled="data.rol === 'AGENT'"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-if="index === 0">
                      <span>{{ item.etiqueta }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text text-caption">
                      (+{{ data.ramos.length - 1 }} más)
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>

              <!-- <v-col cols="12">
                <v-autocomplete
                  v-model="data.canales"
                  :items="listings.canalList"
                  label="Canal"
                  item-text="etiqueta"
                  item-value="id"
                  multiple
                  outlined
                  color="#00a7e4"
                  :disabled="data.rol === 'AGENT'"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-if="index === 0">
                      <span>{{ item.etiqueta }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text text-caption">
                      (+{{ data.canales.length - 1 }} más)
                    </span>
                  </template>
                </v-autocomplete>
              </v-col> -->

              <v-col
                cols="12"
                v-if="
                  data.rol === 'ADMINCC' ||
                    data.rol === 'MANAGERCC' ||
                    data.rol === 'AGENTCC' ||
                    data.rol === 'VALIDADORCC'
                "
              >
                <v-autocomplete
                  v-model="data.landings"
                  :items="listings.landings"
                  label="Productos"
                  item-value="id"
                  item-text="landing"
                  multiple
                  outlined
                  color="#00a7e4"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-if="index === 0">
                      <span>{{ item.landing }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text text-caption">
                      (+{{ data.landings.length - 1 }} más)
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" v-if="showEmpresas">
                <v-select
                  v-model="data.empresas"
                  :items="listings.empresas"
                  label="Empresas"
                  item-text="empresa"
                  item-value="id"
                  multiple
                  outlined
                  color="#00a7e4"
                  :disabled="!canEditEmpresa"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-if="index === 0">
                      <span>{{ item.empresa }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text text-caption">
                      (+{{
                        data.empresas.length ? data.empresas.length - 1 : 0
                      }}
                      más)
                    </span>
                  </template>
                </v-select>
              </v-col>

              <v-col cols="12" v-if="showEmpresas">
                <v-select
                  v-model="data.cuentas_correo"
                  :items="cuentasCorreo"
                  label="Cuentas correo"
                  item-text="cuenta"
                  item-value="id"
                  multiple
                  outlined
                  color="#00a7e4"
                  :disabled="!canEditCuentasCorreo"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-if="index === 0">
                      <span>{{ item.cuenta }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text text-caption">
                      (+{{ data.cuentas_correo.length - 1 }} más)
                    </span>
                  </template>
                </v-select>
              </v-col>

              <v-col cols="12" v-if="showAreasNegocio">
                <v-select
                  v-model="data.areas_negocio"
                  :items="listings.areasNegocios"
                  label="Áreas de negocio"
                  item-text="nombre"
                  item-value="id"
                  multiple
                  outlined
                  color="#00a7e4"
                  :disabled="!canEditAreasNegocio"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip color="primary" v-if="index === 0">
                      <span>{{ item.nombre }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text text-caption">
                      (+{{ data.areas_negocio.length - 1 }} más)
                    </span>
                  </template>
                </v-select>
              </v-col>

              <!-- Área (PBP-2018): visible siempre, no depende del rol del agente visto -->
              <v-col cols="12">
                <v-select
                  label="Área"
                  :items="listings.areasAgente"
                  item-text="name"
                  item-value="id"
                  v-model="data.area"
                  outlined
                  color="#00a7e4"
                  :disabled="!canEditArea"
                />
              </v-col>

              <!-- Estatus de asignación (PBP-2018): visible siempre, no depende del rol del agente visto -->
              <v-col cols="12">
                <v-select
                  label="Estatus"
                  :items="listings.estatusAsignacion"
                  item-text="name"
                  item-value="id"
                  v-model="data.estatusAsignacion"
                  outlined
                  color="#00a7e4"
                  :disabled="!canEditEstatus"
                >
                  <template v-slot:item="{ item }">
                    <v-icon small :color="item.color" class="mr-2">{{ item.icon }}</v-icon>
                    <span>{{ item.name }}</span>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-icon small :color="item.color" class="mr-2">{{ item.icon }}</v-icon>
                    <span>{{ item.name }}</span>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </template>
        </commond-form>

        <div class="mobile-actions">
          <v-btn
            rounded
            dark
            outlined
            color="#00a7e4"
            @click="changeComponent"
            class="mobile-action-button"
          >
            Cancelar
          </v-btn>
          <v-btn
            rounded
            dark
            class="common-botton mobile-action-button"
            @click="formatInfoComplete"
          >
            Guardar
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CommondForm from "@/components/commonComponents/CommondForm.vue";
import moment from "moment";
import { getCuentasCorreoListByParams } from "@/services/cuentasCorreo/cuentasCorreo.service.js";
import EmpresaSelector from "@/components/commonComponents/EmpresaSelector.vue";

export default {
  components: {
    CommondForm,
    EmpresaSelector,
  },
  props: {
    personalData: Object,
    routesConfig: Object,
    listings: Object,
  },
  data() {
    return {
      run: false,
      data: {},
      requiredRule: [(v) => !!v || "El campo es requerido"],
      menuFechaIngreso: false,
      fechaIngresoFormatted: "",
      cuentasCorreo: [],
      prevRol: null,
      currentUserRole:
        JSON.parse(localStorage.getItem("roles"))?.[0]?.rol || null,
      currentUserMail: (localStorage.getItem("agenteMail") || "").toLowerCase(),
      turnoList: [
        { id: 1, turno: "Matutino" },
        { id: 2, turno: "Vespertino" },
        { id: 3, turno: "Completo" },
      ],
    };
  },
  watch: {
    "data.fecha_ingreso"(val) {
      if (val) {
        this.fechaIngresoFormatted = moment(val, "YYYY-MM-DD").format(
          "DD/MM/YYYY",
        );
      }
    },
    "data.rol"(newRol, oldRol) {
      // oldRol a veces viene undefined al inicio
      const prev = oldRol ?? this.prevRol;

      const wasPostVenta = this.isPostVentaRolByRol(prev);
      const isPostVenta = this.isPostVentaRolByRol(newRol);

      // 1) Si salgo de POST-VENTA -> limpio TODO lo de postventa
      if (wasPostVenta && !isPostVenta) {
        this.data.areas_negocio = [];
        this.data.empresas = [];
        this.data.cuentas_correo = [];
      }

      // 2) Si entro a POST-VENTA -> turno fijo y limpio campañas si no aplican
      if (!wasPostVenta && isPostVenta) {
        this.data.turno = 3;

        // Si tu rol postventa NO usa campañas, limpia landings
        if (!this.isCampaniaRol(newRol)) {
          this.data.landings = [];
        }
      }

      // 3) Si el nuevo rol NO es de campañas -> asegúrate que no se quede basura
      if (!this.isCampaniaRol(newRol)) {
        this.data.landings = [];
      }

      // 4) Extensión solo si aplica
      if (newRol !== "VALIDADORCC") {
        this.data.extension = null;
      }

      this.prevRol = newRol;
      this.data.turno = this.normalizeTurno(this.data.turno);
    },
  },
  methods: {
    changeComponent() {
      this.$emit("changeComponent", 1);
    },
    formatInfoComplete() {
      if (this.data.fecha_ingreso) {
        this.data.fecha_ingreso = moment(
          this.data.fecha_ingreso,
          "YYYY-MM-DD",
        ).format("YYYY-MM-DD HH:mm:ss");
      }
      this.run = true;
    },
    afterSuccess() {
      this.run = false;
      this.$emit("changeComponent", 1);

      // recarga la vista actual con router
      this.$router.go(0);
    },
    async getCuentasCorreoListByParams() {
      const body = {
        pagina: 1,
        elementosPagina: 100,
      };
      const response = await getCuentasCorreoListByParams(body);
      this.cuentasCorreo = response.cuentas ?? [];
    },
    isCampaniaRol(rol) {
      return rol === "ADMINCC" || rol === "MANAGERCC" || rol === "AGENTCC";
    },

    isPostVentaRolByRol(rol) {
      if (!rol) return false;

      // 1) por ID
      const id = String(rol).toUpperCase();
      if (
        id.includes("EMAILS") ||
        id.includes("INBOUND") ||
        id.includes("POSTVENTA")
      ) {
        return true;
      }

      // 2) por nombre del catálogo de roles
      const sel = (this.listings.roles || []).find((r) => r.id === rol);
      const nombre = (sel?.nombre || "").toString().toUpperCase();

      return nombre.includes("POST-VENTA") || nombre.includes("POSTVENTA");
    },
    normalizeTurno(val) {
      const num = Number(val);
      if (!Number.isNaN(num) && [1, 2, 3].includes(num)) return num;

      const s = (val || "")
        .toString()
        .trim()
        .toLowerCase();
      if (s === "matutino") return 1;
      if (s === "vespertino") return 2;
      if (s === "completo") return 3;

      return null;
    },
  },
  async mounted() {
    this.data = {
      ...this.personalData,
      ramos: this.personalData.ramos || [],
      canales: this.personalData.canales || this.personalData.canal || [],
      landings: this.personalData.landings || [],
      empresas: this.personalData.empresas || [],
      cuentas_correo: this.personalData.cuentas_correo || [],
      areas_negocio: this.personalData.areas_negocio || [],
      callCenter: this.personalData.callCenter || null,
      area: this.personalData.area ?? null,
      estatusAsignacion: this.personalData.estatusAsignacion ?? 1,
    };
    this.data.turno = this.normalizeTurno(this.data.turno);

    // normalizar fecha ingreso que viene como DD/MM/YYYY
    if (this.data.fecha_ingreso) {
      const parsed = moment(this.data.fecha_ingreso, "DD/MM/YYYY");
      if (parsed.isValid()) {
        this.data.fecha_ingreso = parsed.format("YYYY-MM-DD");
        this.fechaIngresoFormatted = parsed.format("DD/MM/YYYY");
      }
    }

    await this.getCuentasCorreoListByParams();

    // POST-VENTA: turno fijo Completo
    if (this.isPostVentaRol) {
      this.data.turno = 3;
    }
    this.prevRol = this.data.rol;
  },
  computed: {
    showTurno() {
      const t = (this.data.turno || "").toString().trim();
      return t.length > 0;
    },
    showAreasNegocio() {
      return this.isPostVentaRol;
    },
    isPostVentaRol() {
      const sel = (this.listings.roles || []).find(
        (r) => r.id === this.personalData.rol,
      );
      const nombre = (sel?.nombre || "").toString().toUpperCase();
      const rolId = (this.personalData.rol || "").toString().toUpperCase();

      const nombreNormalizado = nombre.replace(/[\s\-_]/g, "");
      const rolIdNormalizado = rolId.replace(/[\s\-_]/g, "");

      return (
        nombreNormalizado.includes("POSTVENTA") ||
        rolIdNormalizado.includes("POSTVENTA")
      );
    },
    areasNegociosFiltradas() {
      if (!this.isPostVentaRol) return this.listings.areasNegocios || [];
      return (this.listings.areasNegocios || []).filter((a) =>
        (a.nombre || "")
          .toString()
          .toUpperCase()
          .includes("ECI - POST-VENTA"),
      );
    },
    isEditingSelf() {
      const mail = (this.data?.correo || this.data?.email || "").toLowerCase();
      return !!mail && mail === this.currentUserMail;
    },

    canEditCoreFields() {
      const allowed = new Set([
        "ADMIN",
        "ADMINCC",
        "MANAGERCC",
        "GERENTEPOSTVENTA",
        "MANAGERCCALIANZAS",
        "MANAGEREMAILS",
        "MANAGERINBOUND",
        "OPERACIONESEMAILS",
        "OPERACIONESINBOUND",
      ]);
      return allowed.has(this.currentUserRole);
    },

    canEditRol() {
      if (!this.canEditCoreFields) return false;
      if (this.currentUserRole === "ADMINCC" && this.isEditingSelf)
        return false;
      return true;
    },

    // Ramo editable (incluye ADMIN/ADMINCC)
    canEditRamo() {
      return this.canEditCoreFields;
    },

    // Empresa editable: mismos que core
    canEditEmpresa() {
      return this.canEditCoreFields;
    },

    // Cuentas correo editable
    canEditCuentasCorreo() {
      return this.canEditCoreFields;
    },

    // Áreas de negocio editable
    canEditAreasNegocio() {
      return this.canEditCoreFields;
    },

    // Campaña editable: ADMIN, ADMINCC, MANAGERCC
    canEditCampania() {
      const allowed = new Set([
        "ADMIN",
        "ADMINCC",
        "MANAGERCC",
        "MANAGERCCALIANZAS",
      ]);
      return allowed.has(this.currentUserRole);
    },

    // Extensión editable: ADMIN y MANAGERCC
    canEditExtension() {
      const allowed = new Set(["ADMIN", "MANAGERCC"]);
      return allowed.has(this.currentUserRole);
    },

    // Área editable: MANAGEREMAILS y GERENTEPOSTVENTA (PBP-2018)
    canEditArea() {
      const allowed = new Set(["MANAGEREMAILS", "GERENTEPOSTVENTA"]);
      return allowed.has(this.currentUserRole);
    },

    // Estatus de asignación editable: MANAGEREMAILS y GERENTEPOSTVENTA (PBP-2018)
    canEditEstatus() {
      const allowed = new Set(["MANAGEREMAILS", "GERENTEPOSTVENTA"]);
      return allowed.has(this.currentUserRole);
    },
    showEmpresas() {
      return this.isPostVentaRol;
    },
  },
};
</script>

<style scoped>
@media (max-width: 959px) {
  .mobile-container {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .mobile-actions {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .mobile-action-button {
    width: 100%;
    max-width: 300px;
    text-align: center;
    font-weight: bold;
  }
}
</style>
